<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import windowsLinuxShortcutsImage from 'dashboard/assets/images/keyboard-shortcuts/atalho_teclado_win_linux.png';
import macShortcutsImage from 'dashboard/assets/images/keyboard-shortcuts/atalho_teclado_mac.png';
import { KEYBOARD_SHORTCUT_PLATFORMS } from './keyboardShortcutPlatforms';

const props = defineProps({
  show: Boolean,
  platform: {
    type: String,
    default: KEYBOARD_SHORTCUT_PLATFORMS.WINDOWS_LINUX,
    validator: value =>
      Object.values(KEYBOARD_SHORTCUT_PLATFORMS).includes(value),
  },
});
defineEmits(['close']);

const { t } = useI18n();
const selectedPlatform = computed(() => {
  const isMac = props.platform === KEYBOARD_SHORTCUT_PLATFORMS.MAC;
  if (isMac) {
    return {
      image: macShortcutsImage,
      title: t('KEYBOARD_SHORTCUTS.PLATFORMS.MAC.TITLE'),
      alt: t('KEYBOARD_SHORTCUTS.PLATFORMS.MAC.ALT'),
    };
  }

  return {
    image: windowsLinuxShortcutsImage,
    title: t('KEYBOARD_SHORTCUTS.PLATFORMS.WINDOWS_LINUX.TITLE'),
    alt: t('KEYBOARD_SHORTCUTS.PLATFORMS.WINDOWS_LINUX.ALT'),
  };
});
</script>

<template>
  <woot-modal :show="show" size="medium" :on-close="() => $emit('close')">
    <div class="flex flex-col max-h-[calc(100vh-6rem)] min-h-0">
      <woot-modal-header :header-title="selectedPlatform.title" />
      <div class="overflow-auto px-4 pb-6 mt-4 sm:px-8">
        <img
          :key="platform"
          data-test-id="keyboard-shortcuts-image"
          :src="selectedPlatform.image"
          :alt="selectedPlatform.alt"
          class="block w-full min-w-[42rem] h-auto object-contain sm:min-w-0"
        />
      </div>
    </div>
  </woot-modal>
</template>
